// @ts-nocheck
import IMask, { FactoryOpts } from "imask";
import { useEffect, useRef } from "react";

export type FieldMaskOptions = FactoryOpts;
export type FieldMaskReturnType = Omit<ReturnType<typeof IMask["createMask"]>, "updateOptions"> & {
    updateOptions: (opts: Partial<FieldMaskOptions>) => void;
};

const useFieldMask = (options: FieldMaskOptions, value?: string, updateFunction?: (value: string) => void) => {
    const maskRef = useRef(IMask.createMask(options));

    useEffect(() => {
        if (value && maskRef.current.value !== value) {
            maskRef.current.resolve(value || "");
            updateFunction?.(maskRef.current.value);
        }
    }, [value]);

    return maskRef.current as FieldMaskReturnType;
};

export default useFieldMask;
